// Generated by CoffeeScript 2.7.0
var Edge;

export default Edge = {
  props: {
    edge: {
      type: Skylark.App.Model.YetAnotherWorkflow.Edge,
      required: true
    },
    selectedEdges: {
      type: Array,
      default: function() {
        return [];
      }
    },
    vertexSize: {
      required: true
    },
    dragStates: Object
  },
  inject: ['adjustByZoom'],
  template: `<g class='graph-edge'
   @click='selectEdge'
   :class='statusClass'>
  <svg>
    <path v-for='(point_pair, index) in pointPairs'
          :key='index'
          :d='_pointpairToPath(point_pair)' />
    <path :d='arrowPath' />
    <circle :cx='startPoint[0]' :cy='startPoint[1]' r='4.5' @mousedown="ctrlMousedownFunc('from', $event)" />
    <circle :cx='endPoint[0]' :cy='endPoint[1]' r='4.5' @mousedown="ctrlMousedownFunc('to', $event)" />
  </svg>
</g>`,
  computed: {
    pointPairs: function() {
      var i, pairs, points;
      points = this.edge.parseToPolylinePoints(this.vertexSize.width, this.vertexSize.height, this.vertexSize.buffer_width);
      pairs = [];
      i = 0;
      while (i < points.length - 1) {
        pairs.push(points.slice(i, i + 2));
        i += 1;
      }
      return pairs;
    },
    startPoint: function() {
      return this.pointPairs[0][0];
    },
    endPoint: function() {
      return _.last(this.pointPairs)[1];
    },
    arrowPath: function() {
      var arrow_offset, dir, end, start;
      arrow_offset = 5;
      this.endPoint;
      dir = this.edge.metadata.connection_direction.to;
      if (Math.abs(dir) === 1) {
        start = [this.endPoint[0] - arrow_offset, this.endPoint[1] - dir * arrow_offset];
        end = [this.endPoint[0] + arrow_offset, this.endPoint[1] - dir * arrow_offset];
      } else {
        dir = dir / Math.abs(dir);
        start = [this.endPoint[0] + dir * arrow_offset, this.endPoint[1] - arrow_offset];
        end = [this.endPoint[0] + dir * arrow_offset, this.endPoint[1] + arrow_offset];
      }
      return this._pointsToLine([start, this.endPoint, end]);
    },
    statusClass: function() {
      return {
        focused: _.contains(this.selectedEdges, this.edge),
        unavailable: this.edge._status === 'unavailable',
        danger: this.edge._status === 'danger',
        limited: this.edge.conditions.length
      };
    }
  },
  created: function() {
    return _.each(['ctrlMousemove', 'ctrlMouseup'], (event_type) => {
      return this[`${event_type}Func`] = this[event_type].bind(this);
    });
  },
  methods: {
    ctrlMousedownFunc: function(key, event) {
      event.stopPropagation();
      if (event.which !== 1) {
        return;
      }
      this.dragStates.key = key;
      this.dragStates.start = {
        x: event.clientX,
        y: event.clientY
      };
      document.body.addEventListener('mousemove', this.ctrlMousemoveFunc, false);
      return document.body.addEventListener('mouseup', this.ctrlMouseupFunc, false);
    },
    ctrlMousemove: function(event) {
      var delta_x, delta_y, key, new_edge, position, reverse_key, vertex;
      this.dragStates.enable = true;
      delta_x = this.adjustByZoom(event.clientX - this.dragStates.start.x);
      delta_y = this.adjustByZoom(event.clientY - this.dragStates.start.y);
      key = this.dragStates.key;
      this.edge.setStatus('unavailable');
      vertex = this.edge[key];
      if ((vertex.isInitial || vertex.isFinal) && vertex.graph !== this.edge.graph) {
        vertex = vertex.graph;
      }
      position = vertex.metadata.position;
      reverse_key = key === 'from' ? 'to' : 'from';
      new_edge = {
        _status: 'uncentainVertex'
      };
      new_edge[reverse_key] = this.edge[reverse_key];
      new_edge[key] = {
        metadata: {
          position: {
            x: position.x + delta_x,
            y: position.y + delta_y
          }
        }
      };
      new_edge.metadata = {
        connection_direction: {
          [`${reverse_key}`]: this.edge.metadata.connection_direction[reverse_key],
          [`${key}`]: this.edge.metadata.connection_direction[key]
        },
        uncentain_key: key
      };
      return this.$emit('addPreparedEdge', new_edge, this.edge);
    },
    ctrlMouseup: function(event) {
      document.body.removeEventListener('mousemove', this.ctrlMousemoveFunc, false);
      document.body.removeEventListener('mouseup', this.ctrlMouseupFunc, false);
      if (this.dragStates.enable) {
        this.$emit('prepareEdgeEnd', this.edge);
      }
      this.dragStates.start = {
        x: 0,
        y: 0
      };
      this.dragStates.enable = false;
      return this.dragStates.key = 'from';
    },
    selectEdge: function(event) {
      return this.$emit('focusEdge', this.edge);
    },
    _pointsToLine: function(points) {
      var _result, line_points, move_point;
      move_point = points[0];
      line_points = points.slice(1);
      _result = _.map(line_points, function(point) {
        return `L ${point[0]} ${point[1]}`;
      });
      _result.unshift(`M ${move_point[0]} ${move_point[1]}`);
      return _result.join(' ');
    },
    _pointpairToPath: function(points) {
      return this._pointsToLine(points);
    }
  }
};
